// removed by extract-text-webpack-plugin
module.exports = {"sendForgotPasswordModal":"qempo_SendForgotPasswordModal_sendForgotPasswordModal-fkPxc08","authForm":"qempo_SendForgotPasswordModal_authForm-29XvQTd","row":"qempo_SendForgotPasswordModal_row-3hWjZRy","red":"qempo_SendForgotPasswordModal_red-1EtZJq4","lowerError":"qempo_SendForgotPasswordModal_lowerError-1_mJwVp","submitBtn":"qempo_SendForgotPasswordModal_submitBtn-1LOQrPR","modalLoading":"qempo_SendForgotPasswordModal_modalLoading-brJX9dc"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/auth-modals/forgot-password-modal/components/SendForgotPasswordModal/SendForgotPasswordModal.scss
// module id = 1933
// module chunks = 0